'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { Button } from '@mokoboko/components';

import { PageState, PageStateScreen } from '@/components/ui/page-state';
import { PageStateBrand } from '@/components/ui/page-state-brand';
import { captureError } from '@/lib/capture-error';

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function Error({ error, reset }: ErrorProps) {
  const router = useRouter();

  useEffect(() => {
    // ChunkLoadError means the user has a stale tab open after a deployment.
    // Auto-reload to fetch the new chunks instead of showing an error screen.
    if (error.name === 'ChunkLoadError') {
      window.location.reload();
      return;
    }

    captureError({
      error,
      source: 'ui_crash',
      context: { digest: error.digest },
    });
  }, [error]);

  return (
    <PageStateScreen>
      <PageState
        image="/images/cone-3d.webp"
        header={<PageStateBrand />}
        title="Something went wrong"
        description="We have been notified and are fixing it."
        actions={
          <>
            <Button size="lg" className="w-full xs:w-auto" onClick={reset}>
              Try again
            </Button>
            <Button
              size="lg"
              variant="secondary-gray"
              className="w-full xs:w-auto"
              onClick={() => router.push('/home')}
            >
              Go to home
            </Button>
          </>
        }
      />
    </PageStateScreen>
  );
}
